// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_e7-0";
export var actionModalContentContainer = "_e7-1";
export var createTagButton = "_e7-2";
export var footerContainer = "_e7-7";
export var fullWidthDivider = "_e7-3";
export var hasCreateTagButton = "_e7-4";
export var noCreateTagButton = "_e7-5";
export var tagsContainer = "_e7-6";
export var tagsModalContentContainer = "_e7-8";